import { resolveMediaUrl, stripHiraysMediaFromHtml } from './media'

export const NEWS_TYPE_SLUG = {
  0: 'tech-wiki',
  1: 'company-news',
  2: 'exhibition',
  3: 'industry',
  4: 'social'
}

let newsSlugByType = { ...NEWS_TYPE_SLUG }
let newsTypeBySlug = Object.keys(NEWS_TYPE_SLUG).reduce((acc, key) => {
  acc[NEWS_TYPE_SLUG[key]] = Number(key)
  return acc
}, {})

export function syncNewsNavCategories(categories) {
  const slugByType = { ...NEWS_TYPE_SLUG }
  const typeBySlug = {}
  ;(categories || []).forEach(item => {
    if (item.slug && item.newsType != null) {
      slugByType[item.newsType] = item.slug
      typeBySlug[item.slug] = item.newsType
    }
  })
  newsSlugByType = slugByType
  newsTypeBySlug = typeBySlug
}

export function getNewsTypeBySlug(slug) {
  if (!slug) return null
  return newsTypeBySlug[slug] != null ? newsTypeBySlug[slug] : null
}

export function getNewsSlugByType(type) {
  return newsSlugByType[type] || NEWS_TYPE_SLUG[type] || 'company-news'
}

export function cleanBrandText(text) {
  if (text == null || text === '') return ''
  return stripHiraysMediaFromHtml(String(text))
    .replace(/\u6DF1\u5733\u5E02\u6D77\u745E\u601D\u81EA\u52A8\u5316\u79D1\u6280\u6709\u9650\u516C\u53F8/g, '\u8BDA\u6D2A\u79D1\u6280\u6709\u9650\u516C\u53F8')
    .replace(/\u6D77\u745E\u601D\u81EA\u52A8\u5316\u79D1\u6280/g, '\u8BDA\u6D2A\u79D1\u6280')
    .replace(/\u6D77\u745E\u601D/g, '\u8BDA\u6D2A\u79D1\u6280')
    .replace(/Shenzhen Hirays Automation Technology Co\., Ltd\.?/gi, 'Chenghong Technology Co., Ltd.')
    .replace(/Hirays Measurement & Control/gi, 'Chenghong Measurement & Control')
    .replace(/Hirays/gi, 'Chenghong Technology')
}

export function localizeBrandText(text, locale) {
  let s = cleanBrandText(text)
  if (locale === 'zh') {
    s = s.replace(/Chenghong Technology Co\., Ltd\./g, '\u8BDA\u6D2A\u79D1\u6280\u6709\u9650\u516C\u53F8')
    s = s.replace(/Chenghong Measurement & Control/g, '\u8BDA\u6D2A\u6D4B\u63A7')
    s = s.replace(/Chenghong Technology/g, '\u8BDA\u6D2A\u79D1\u6280')
  }
  return s
}

export function stripHtml(text) {
  if (!text) return ''
  const div = document.createElement('div')
  div.innerHTML = text
  return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim()
}

export function truncateSummary(text, maxLen = 120) {
  const plain = stripHtml(text)
  if (plain.length <= maxLen) return plain
  return plain.substring(0, maxLen) + '...'
}

export function parseStatNumber(value) {
  if (value == null || value === '') return 0
  const cleaned = String(value).replace(/[,+\s]/g, '').replace(/[㎡m²]/gi, '')
  const match = cleaned.match(/[\d.]+/)
  return match ? parseFloat(match[0]) : 0
}

export function splitStatValue(value) {
  const raw = String(value || '').trim()
  if (!raw) return { value: 0, display: '', suffix: '' }
  let suffix = ''
  if (/[㎡m²]/i.test(raw)) suffix = '㎡'
  else if (raw.includes('+')) suffix = '+'
  else if (/项$/.test(raw)) suffix = '项'
  let display = raw
  if (suffix === '+') display = raw.replace(/\+/g, '').trim()
  else if (suffix === '㎡') display = raw.replace(/[㎡m²]/gi, '').trim()
  else if (suffix === '项') display = raw.replace(/项$/g, '').trim()
  display = display.replace(/,/g, '')
  return {
    value: parseStatNumber(display),
    display,
    suffix
  }
}

function resolveStatSuffixClass(suffix) {
  if (suffix === '项') return 'f20'
  if (suffix === '+' || suffix === '㎡') return 'f33'
  return ''
}

function normalizeStatLabel(display, suffix, label) {
  let text = cleanBrandText(label || '')
  if (!suffix && text.startsWith('项') && /^\d+$/.test(String(display))) {
    return { suffix: '项', label: text.slice(1) || text }
  }
  return { suffix, label: text }
}

export function formatStatDisplay(value) {
  return splitStatValue(value).display
}

export function mapSiteStats(rows) {
  if (!rows || !rows.length) return []
  return rows
    .filter(item => item.status === 1)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(item => {
      const parts = splitStatValue(item.statValue)
      const normalized = normalizeStatLabel(parts.display, parts.suffix, item.statLabel)
      const suffix = normalized.suffix
      return {
        value: parts.value,
        display: parts.display,
        suffix,
        suffixClass: resolveStatSuffixClass(suffix),
        label: normalized.label
      }
    })
}

export function mapNewsItem(item) {
  const date = item.sendTime || item.createTime || ''
  return {
    id: item.id,
    category: getNewsSlugByType(item.type),
    type: item.type,
    title: cleanBrandText(stripHtml(item.title)),
    summary: truncateSummary(cleanBrandText(item.content || '')),
    image: resolveImageUrl(item.picUrl),
    date: String(date).substring(0, 10),
    content: cleanBrandText(item.content)
  }
}

export function resolveImageUrl(path) {
  if (!path) return ''
  return resolveMediaUrl(String(path).trim())
}

export function parsePicUrlList(picUrl) {
  if (!picUrl) return []
  return String(picUrl)
    .split(/[,，]/)
    .map(s => resolveImageUrl(s.trim()))
    .filter(Boolean)
}

export function parseCultureLines(content) {
  if (!content) return null
  const icons = ['icon-qywh1', 'icon-qywh2', 'icon-qywh3', 'icon-qywh4', 'icon-qywh5', 'icon-qywh6']
  const plain = stripHtml(content)
  const lines = plain.split(/\n|；|;/).map(s => s.trim()).filter(Boolean)
  if (!lines.length) return null
  const items = lines.map((line, i) => {
    const parts = line.split(/[:：|]/).map(s => s.trim()).filter(Boolean)
    if (parts.length >= 2) {
      return { icon: icons[i % icons.length], title: parts[0], desc: parts.slice(1).join(' ') }
    }
    return { icon: icons[i % icons.length], title: parts[0], desc: '' }
  })
  return items.length ? items : null
}

function formatJobDate(value) {
  if (!value) return '-'
  const s = String(value)
  return s.length >= 10 ? s.substring(0, 10) : s
}

function jobFromMeta(meta, content) {
  return {
    title: cleanBrandText(meta.title || ''),
    location: meta.location || '-',
    dept: meta.dept || '-',
    type: meta.type || '-',
    date: meta.date || '-',
    content: content || ''
  }
}

function parseJobMetaLine(line) {
  const text = String(line || '').trim()
  if (!text || !text.includes('|')) return null
  const parts = text.split('|').map(s => s.trim()).filter(Boolean)
  if (parts.length < 2) return null
  if (parts.length >= 5) {
    return { title: parts[0], location: parts[1], dept: parts[2], type: parts[3], date: parts[4] }
  }
  if (parts.length === 4) {
    return { title: parts[0], location: parts[1], dept: parts[2], type: parts[3], date: '-' }
  }
  return { title: parts[0], location: parts[1], dept: parts[2] || '-', type: '-', date: '-' }
}

export function mapCompanyInfoRowToJob(row) {
  if (!row) return null
  const content = row.content || ''
  const firstLine = stripHtml(content).split(/\n/)[0].trim()
  if (firstLine.includes('|')) {
    const parts = firstLine.split('|').map(s => s.trim())
    const body = content.replace(/^<p>[^<]*\|[^<]*<\/p>/i, '').trim() || content
    if (parts.length === 4 && row.title) {
      return jobFromMeta({
        title: row.title,
        location: parts[0],
        dept: parts[1],
        type: parts[2],
        date: parts[3]
      }, body)
    }
    const metaFromContent = parseJobMetaLine(firstLine)
    if (metaFromContent) {
      return jobFromMeta(metaFromContent, body)
    }
  }
  return jobFromMeta({
    title: row.title || '',
    location: '-',
    dept: '-',
    type: '-',
    date: formatJobDate(row.createTime)
  }, content)
}

export function parseJobItemsFromHtml(html) {
  if (!html) return []
  const src = String(html).trim()
  const jobs = []

  const rowMatches = src.match(/<tr[^>]*>[\s\S]*?<\/tr>/gi) || []
  if (rowMatches.length > 1) {
    rowMatches.slice(1).forEach(tr => {
      const cells = (tr.match(/<t[dh][^>]*>([\s\S]*?)<\/t[dh]>/gi) || [])
        .map(c => stripHtml(c))
        .filter(Boolean)
      if (!cells.length) return
      jobs.push(jobFromMeta({
        title: cells[0],
        location: cells[1] || '-',
        dept: cells[2] || '-',
        type: cells[3] || '-',
        date: cells[4] || '-'
      }, cells.slice(5).join('<br/>') || ''))
    })
    if (jobs.length) return jobs
  }

  const blocks = src.split(/<hr\s*\/?>|<p>\s*---+?\s*<\/p>|(?:^|\n)\s*---+\s*(?:\n|$)/i).map(s => s.trim()).filter(Boolean)
  blocks.forEach(block => {
    const plainFirst = stripHtml(block).split(/\n/)[0].trim()
    const meta = parseJobMetaLine(plainFirst)
    if (meta) {
      let body = block.replace(/^<p>[^<]*\|[^<]*<\/p>/i, '').trim()
      if (!body) body = block
      jobs.push(jobFromMeta(meta, body))
      return
    }
    const heading = block.match(/^<h[34][^>]*>([\s\S]*?)<\/h[34]>/i)
    if (heading) {
      jobs.push(jobFromMeta({
        title: stripHtml(heading[1]),
        location: '-',
        dept: '-',
        type: '-',
        date: '-'
      }, block.replace(heading[0], '').trim()))
    }
  })
  if (jobs.length) return jobs

  const headingParts = src.split(/(?=<h[34][^>]*>)/i).map(s => s.trim()).filter(Boolean)
  if (headingParts.length > 1) {
    headingParts.forEach(part => {
      const heading = part.match(/^<h[34][^>]*>([\s\S]*?)<\/h[34]>/i)
      if (!heading) return
      jobs.push(jobFromMeta({
        title: stripHtml(heading[1]),
        location: '-',
        dept: '-',
        type: '-',
        date: '-'
      }, part.replace(heading[0], '').trim()))
    })
  }
  return jobs
}

export function parseManufacturingPanels(content) {
  if (!content) return null
  const lines = stripHtml(content)
    .split(/\n|<br\s*\/?>/i)
    .map(s => s.trim())
    .filter(Boolean)
  const panels = lines.map(line => {
    const parts = line.split(/[:：|]/).map(s => s.trim()).filter(Boolean)
    if (parts.length >= 2) {
      return { title: cleanBrandText(parts[0]), desc: cleanBrandText(parts.slice(1).join(' ')) }
    }
    return null
  }).filter(Boolean)
  return panels.length ? panels : null
}

export function parseHistoryStages(content) {
  if (!content) return null
  const src = String(content).trim()
  const blocks = src
    .split(/<hr\s*\/?>|<p>\s*---+?\s*<\/p>|(?:^|\n)\s*---+\s*(?:\n|$)/i)
    .map(s => s.trim())
    .filter(Boolean)
  if (!blocks.length) return null

  const stages = blocks.map((block, idx) => {
    const lines = stripHtml(block)
      .split(/\n|<br\s*\/?>/i)
      .map(s => s.trim())
      .filter(Boolean)
    if (!lines.length) return null

    const head = lines[0].split('|').map(s => s.trim())
    let title = ''
    let subtitle = ''
    let summary = ''
    let startIdx = 1

    if (head.length >= 3) {
      title = head[0]
      subtitle = head[1]
      summary = head.slice(2).join('|')
    } else if (head.length === 2) {
      title = head[0]
      summary = head[1]
    } else {
      title = `Stage ${idx + 1}`
      startIdx = 0
    }

    const years = []
    for (let i = startIdx; i < lines.length; i++) {
      const line = lines[i]
      const colonMatch = line.match(/^(\d{4})\s*[:：]\s*(.+)$/)
      if (colonMatch) {
        years.push({ year: colonMatch[1], text: cleanBrandText(colonMatch[2]) })
        continue
      }
      const pipeParts = line.split('|').map(s => s.trim())
      if (pipeParts.length >= 2 && /^\d{4}$/.test(pipeParts[0])) {
        years.push({ year: pipeParts[0], text: cleanBrandText(pipeParts.slice(1).join('|')) })
      }
    }

    if (!years.length && !summary && !title) return null
    return {
      slug: `cms-stage-${idx}`,
      title: cleanBrandText(title),
      subtitle: cleanBrandText(subtitle),
      summary: cleanBrandText(summary),
      years
    }
  }).filter(Boolean)

  return stages.length ? stages : null
}

export function extractImgSrcs(html) {
  if (!html) return []
  const matches = String(html).match(/src=["']([^"']+)["']/gi) || []
  return matches
    .map(m => m.replace(/^src=["']/i, '').replace(/["']$/, ''))
    .map(resolveImageUrl)
    .filter(Boolean)
}

export function unwrapRows(res) {
  if (!res) return []
  if (Array.isArray(res.rows)) return res.rows
  if (Array.isArray(res.data)) return res.data
  if (res.data && Array.isArray(res.data.rows)) return res.data.rows
  return []
}

export function unwrapData(res) {
  if (!res) return null
  if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) return res.data
  return res
}

function firstProductImage(picUrl) {
  if (!picUrl) return ''
  const raw = String(picUrl).split(',')[0].trim()
  return resolveImageUrl(raw)
}

function parsePrecisionLabel(label) {
  if (!label) return { precision: '10', precisionSup: '-1' }
  const m = String(label).match(/([\d.]+)\s*[-~]\s*([\d.]+)/)
  if (m) return { precision: m[1], precisionSup: '-' + m[2].replace(/^-/, '') }
  const single = String(label).match(/([\d.]+)/)
  return { precision: single ? single[1] : '10', precisionSup: '-1' }
}

export function mapHomeProductCategories(categories, products) {
  const byCat = {}
  ;(products || []).forEach(p => {
    const cid = p.categoryId
    if (!byCat[cid]) byCat[cid] = []
    byCat[cid].push({
      id: p.id,
      name: cleanBrandText(p.productName || ''),
      shortName: cleanBrandText(p.productRemark || p.productName || ''),
      image: firstProductImage(p.picUrl),
      linkUrl: String(p.linkUrl || p.link_url || '').trim()
    })
  })
  return (categories || [])
    .filter(c => c.status === 1)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(c => {
      const prec = parsePrecisionLabel(c.precisionLabel)
      return {
        slug: c.categorySlug || String(c.id),
        name: cleanBrandText(c.categoryName || ''),
        image: resolveImageUrl(c.picUrl),
        precision: prec.precision,
        precisionSup: prec.precisionSup,
        products: byCat[c.id] || []
      }
    })
    .filter(c => c.products.length > 0 || c.image)
}

function isCmsMediaUrl(url) {
  if (!url) return false
  const p = String(url).trim()
  if (!p) return false
  // Ignore seeded local defaults — only real CMS/OSS/uploads count
  if (p.startsWith('/images/solutions/')) return false
  if (p.includes('i-bg1.png') || p.includes('i-bg2.jpg') || p.includes('grey.gif')) return false
  if (p.includes('placeholder')) return false
  return true
}

export function mapHomeSolutionSlides(categories) {
  const slides = (categories || [])
    .filter(c => Number(c.status) === 1 && (Number(c.categoryType) === 0 || c.categoryType == null))
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || Number(a.id) - Number(b.id))
    .map(c => {
      const imageRaw = c.picUrl || ''
      const thumbRaw = c.thumbUrl || ''
      return {
        id: c.id,
        slug: c.categorySlug || String(c.id),
        name: cleanBrandText(c.categoryName || ''),
        desc: cleanBrandText(c.description || ''),
        linkUrl: String(c.linkUrl || c.link_url || '').trim(),
        image: isCmsMediaUrl(imageRaw) ? resolveImageUrl(imageRaw) : '',
        thumb: isCmsMediaUrl(thumbRaw) ? resolveImageUrl(thumbRaw) : ''
      }
    })
  return slides
}

export const MODEL_BANNER_KEY = {
  0: 'product',
  1: 'news',
  2: 'solution',
  3: 'about',
  4: 'contact',
  5: 'service'
}

export function isVideoUrl(path) {
  if (!path) return false
  return /\.(mp4|webm|ogg)(\?.*)?$/i.test(String(path).trim())
}

export function mapProductMegaNav(categories, products) {
  const catList = (categories || [])
    .filter(r => r.status === 1 && isValidNavSlug(r.categorySlug))
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))

  const slugByCategoryId = {}
  ;(categories || []).forEach(c => {
    if (c.id != null && c.categorySlug) slugByCategoryId[c.id] = c.categorySlug
  })

  return catList.map(cat => {
    const catProducts = (products || [])
      .filter(p => {
        if (Number(p.categoryId) === Number(cat.id)) return true
        const linkedSlug = slugByCategoryId[p.categoryId]
        return linkedSlug && linkedSlug === cat.categorySlug
      })
      .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0) || Number(a.id) - Number(b.id))
      .map(p => ({
        id: p.id,
        name: cleanBrandText(p.productName || ''),
        image: resolveImageUrl(p.picUrl) || ''
      }))
    return {
      id: cat.id,
      slug: cat.categorySlug,
      name: cleanBrandText(cat.categoryName || ''),
      products: catProducts
    }
  })
}

export function mapSolutionMegaNav(rows) {
  const list = (rows || [])
    .filter(r => Number(r.status) === 1 && isValidNavSlug(r.categorySlug))
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(r => {
      const cmsImage = resolveImageUrl(r.picUrl) || resolveImageUrl(r.thumbUrl)
      const categoryName = cleanBrandText(r.categoryName || '')
      return {
        id: r.id,
        slug: r.categorySlug,
        categoryName,
        name: categoryName,
        image: cmsImage || ''
      }
    })
  return list
}

export function mapNavCategories(rows, slugField, nameField) {
  return (rows || [])
    .filter(r => Number(r.status) === 1 && isValidNavSlug(r[slugField]))
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(r => ({
      id: r.id,
      slug: r[slugField],
      name: cleanBrandText(r[nameField] || '')
    }))
}

export function mapSiteNavItems(rows, navGroup) {
  const group = Number(navGroup)
  return (rows || [])
    .filter(r => Number(r.status) === 1 && Number(r.navGroup) === group)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(r => {
      let slug = r.itemSlug
      if (!isValidNavSlug(slug)) {
        slug = siteNavSlugByType(group, r.itemType)
      }
      return {
        id: r.id,
        slug,
        name: cleanBrandText(r.itemName || ''),
        hash: r.anchorHash || null,
        itemType: r.itemType
      }
    })
    .filter(r => isValidNavSlug(r.slug))
    .filter(r => group !== 1 || !['manufacturing', 'gallery'].includes(r.slug))
    .filter(r => group !== 0 || r.slug !== 'video-help')
}

const SERVICE_NAV_SLUGS = ['product-support', 'video-help', 'value-added', 'faq']
const ABOUT_NAV_SLUGS = ['company-intro', 'manufacturing', 'history', 'culture', 'rd', 'honors', 'gallery', 'careers']

function siteNavSlugByType(navGroup, itemType) {
  const type = Number(itemType)
  if (navGroup === 0 && type >= 0 && type < SERVICE_NAV_SLUGS.length) {
    return SERVICE_NAV_SLUGS[type]
  }
  if (navGroup === 1 && type >= 0 && type < ABOUT_NAV_SLUGS.length) {
    return ABOUT_NAV_SLUGS[type]
  }
  return ''
}

export function mapNewsNavCategories(rows) {
  const typeSlugs = ['tech-wiki', 'company-news', 'exhibition', 'industry', 'social']
  return (rows || [])
    .filter(r => r.status === 1)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(r => {
      const slug = r.categorySlug || typeSlugs[r.newsType] || String(r.id)
      return {
        slug,
        name: cleanBrandText(r.categoryName || ''),
        newsType: r.newsType
      }
    })
    .filter(r => isValidNavSlug(r.slug))
}

function isValidNavSlug(slug) {
  if (!slug) return false
  const value = String(slug).trim()
  if (/^\d+$/.test(value)) return false
  return /^[a-z][a-z0-9-]*$/i.test(value)
}

export function mapSiteMedia(rows) {
  const pageBanners = {}
  const oneStop = { video: '', poster: '' }
  let productSectionBg = ''
  let solutionsSectionBg = ''
  ;(rows || [])
    .filter(r => Number(r.status) === 1)
    .forEach(row => {
      const type = Number(row.type)
      if (type === 6) {
        if (row.modelPicurl) oneStop.video = resolveImageUrl(row.modelPicurl)
        if (row.nbpicUrl) oneStop.poster = resolveImageUrl(row.nbpicUrl)
        return
      }
      if (type === 11 && row.nbpicUrl) {
        productSectionBg = resolveImageUrl(row.nbpicUrl)
        return
      }
      if (type === 12 && row.nbpicUrl) {
        solutionsSectionBg = resolveImageUrl(row.nbpicUrl)
        return
      }
      const key = MODEL_BANNER_KEY[type]
      if (key && row.nbpicUrl) {
        pageBanners[key] = resolveImageUrl(row.nbpicUrl)
      }
    })
  return { pageBanners, oneStop, productSectionBg, solutionsSectionBg }
}
